import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import LiveTV from './pages/LiveTV';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900">
        <Header currentTime={currentTime} />
        <main>
          <Routes>
            <Route path="/" element={<HomePage currentTime={currentTime} />} />
            <Route path="/live" element={<LiveTV currentTime={currentTime} />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;